import React from 'react';
import { ReactComponent as LogoSvg } from './assets/oeppe.svg'; // Importiere SVG als React Komponente

const LogoImage: React.FC = () => {
    return (
        <div style={{ height: '50px', width: '120px', display: 'flex', alignItems: 'center' }}>
            <LogoSvg style={{ maxHeight: '100%', width: 'auto' }} />
        </div>
    );
};

export default LogoImage;
